export type Payload = {
    authorizeUrl: string;
};

/**
 * Исключение используется в случае ошибок авторизации.
 * HTTP статус код для ошибок валидации: 401 Unauthorized.
 */
export class UnauthorizedException extends Error {
    static readonly NAME = 'UnauthorizedException';

    constructor(data: Blob | Payload) {
        super();
        this.name = UnauthorizedException.NAME;
        this.data = data;
    }

    /**
     * Данные ошибки. Может быть Blob в случае ошибки загрузки файлов
     */
    data: Blob | Payload;

    /**
     * Url авторизации.
     */
    getAuthorizeUrl = async (): Promise<string> => {
        if ((this.data as Payload).authorizeUrl) {
            return (this.data as Payload).authorizeUrl;
        } else {
            const { authorizeUrl: url } = JSON.parse(
                await (this.data as Blob).text(),
            );

            return url;
        }
    };
}
